import { render, staticRenderFns } from "./PreAtendimentoEdit.vue?vue&type=template&id=de57c8d0&"
import script from "./PreAtendimentoEdit.vue?vue&type=script&lang=js&"
export * from "./PreAtendimentoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports